module.exports = __webpack_public_path__ + "img/4.c951dbc1.png";